import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'tr',
    fullName: 'Turkish',
    nativeName: 'Türkçe',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Muhteşem bir şey geliyor",
    landing_subtitle: "ArgVoid bir uygulama ve oyun geliştirme stüdyosudur. Takipte kalın, çok yakında yeni şeyler gelecek!",
    select_language: "Dil Seçiniz",
    search_placeholder: "Dilleri ara...",
    terms_title: "Hizmet Şartları",
    policy_title: "Gizlilik Politikası",
    cookies_title: "Çerez Politikası",
    terms_content: `
        <strong>1. Şartların Kabulü</strong><br>
        ArgVoid'e erişerek bu Hizmet Şartları kabul edilir. Bu şartlar kabul edilmediği takdirde hizmet kullanılmamalıdır.<br><br>

        <strong>2. Platform Kullanımı</strong><br>
        ArgVoid ve uygulamaları bilgilendirme ve yaratıcı amaçlarla "olduğu gibi" sağlanmaktadır. Hizmet yalnızca yasal amaçlarla kullanılmalıdır.<br><br>

        <strong>3. Yasaklanmış Davranış</strong><br>
        Sitedeki güvenlik açıklarından yararlanmak, spam göndermek veya altyapıya yetkisiz erişime teşebbüs etmek kesinlikle yasaktır.<br><br>

        <strong>4. Sorumluluk reddi beyanı</strong><br>
        Platform ve hizmetler herhangi bir zamanda bildirimde bulunmaksızın değiştirilebilir. Hizmetin çalışma süresi veya kullanılabilirliği konusunda hiçbir garanti verilmemektedir.
    `,
    policy_content: `
        <strong>1. Bilgi Toplama</strong><br>
        Platform şu anda kullanıcı kimlik doğrulaması veya hesap oluşturma gerektirmiyor. Ziyaretçilerden aktif olarak hiçbir kişisel tanımlayıcı bilgi (isimler veya e-posta adresleri gibi) toplanmaz.<br><br>

        <strong>2. Kullanım Verileri</strong><br>
        Site trafiğini anlamak ve uygulamaları iyileştirmek için temel, anonimleştirilmiş analizler toplanabilir. Bu veriler bireysel kullanıcı kimlikleriyle bağlantılı değildir.<br><br>

        <strong>3. Üçüncü Taraf Hizmetleri</strong><br>
        Barındırma ve analiz hizmetleri için üçüncü taraf sağlayıcılardan faydalanılabilir. Bu ilgili sağlayıcıların gizlilik uygulamaları, altyapılarında işlenen anonim verileri yönetir.<br><br>

        <strong>4. Veri Güvenliği</strong><br>
        Platformu korumak için makul güvenlik önlemleri uygulanmaktadır. Ancak İnternet üzerinden hiçbir iletim yöntemi tamamen güvenli değildir.<br><br>
    `,
    cookies_content: `
        <strong>1. Çerezler ve Yerel Depolama nedir?</strong><br>
        Çerezler ve tarayıcı yerel depolaması, ziyaretler sırasında yapılandırma tercihlerini hatırlamak için cihazda saklanan küçük veri dosyalarıdır.<br><br>

        <strong>2. Kullanım Amacı</strong><br>
        Tarayıcı LocalStorage, yalnızca aşağıdaki gibi yapılandırma ayarlarını kaydetmek için kullanılır: <br>
        - Dil tercihleri<br>
        - Kullanıcı arayüzü yapılandırması (ör. düzen veya tema ayarları)<br>
        - Geçici uygulama önbelleği<br><br>

        <strong>3. Takip Yok</strong><br>
        Çerezler ve yerel depolama, reklam veya üçüncü taraf izleme amacıyla kullanılmaz. Saklanan tüm veriler kesinlikle platformun temel işlevlerine yöneliktir.<br><br>

        <strong>4. Kontrol</strong><br>
        Tarayıcı verileri, herhangi bir yerel yapılandırmayı sıfırlayacak olan tarayıcı ayarları aracılığıyla herhangi bir zamanda temizlenebilir.
    `,
    cookie_consent_text: "Oturumunuzu aktif tutmak, dil tercihinizi kaydetmek ve diğer özel yapılandırmalar gibi web sitesinin doğru şekilde çalışmasını sağlamak için temel çerezleri kullanırız.",
    read_policy: "Çerez Politikasını Okuyun",
    support_title: "Destek Ekibiyle İletişime Geçin",
    support_subject_label: "Ders",
    support_message_label: "Mesaj",
    support_submit_button: "Mesaj Gönder",
    support_hint: "Not: Bu, mesajı göndermek için varsayılan e-posta uygulamanızı açacaktır.",
    support_success_msg: "E-posta uygulamanız açılıyor...",
    support_error_msg: "Mesaj gönderilemedi. Lütfen daha sonra tekrar deneyin.",
    explorer_title: "Kaşif",
    history_title: "Tarih",
    animation_title: "Animasyon",
    config_title: "Yapılandırma",
    tool_mouse: "Seç (Ctrl+M)",
    tool_brush: "Fırça (Ctrl+B)",
    tool_brush_mode: "Geçiş Modu (Katı/Net)",
    tool_eraser: "Silgi (Ctrl+E)",
    tool_brush_size: "Fırça Boyutunu Ayarla",
    tool_bucket: "Doldur (Ctrl+F)",
    tool_eyedropper: "Damlalık",
    tool_grid: "Izgara (Ctrl+Üst Karakter+B)",
    tool_rotate: "Döndür (Ctrl+Üst Karakter+R)",
    tool_flip_h: "H Çevirme (Ctrl+Shift+H)",
    tool_flip_v: "V Çevir (Ctrl+Üst Karakter+V)",
    tool_transpose: "Transpoze (Ctrl+Shift+T)",
    label_width: "Genişlik",
    label_height: "Yükseklik",
    label_frames: "Çerçeve Sayısı",
    label_animation: "Animasyon Stili",
    label_background_color: "Arka Plan Rengi",
    label_interval: "Aralık",
    tool_anim_config: "Animasyon Yapılandırması",
    label_new_width: "Yeni Genişlik",
    label_new_height: "Yeni Yükseklik",
    label_apply: "Uygula",
    label_colors: "Renkler",
    label_size: "Boyut",
    label_tolerance: "Hoşgörü",
    val_horizontal: "Yatay",
    val_vertical: "Dikey",
    val_sequence: "Sekans",
    val_bounce: "Sıçrama",
    val_random: "Rastgele",
    val_solid: "Sağlam",
    val_clear: "Temizlemek",
    action_add_sheet: "Yeni Sayfa",
    action_import: "İçe aktarmak",
    action_export: "İhracat",
    action_sort_projects: "Düzenlemek",
    sort_date_old: "En Eski İlk",
    sort_date_new: "En Yeni İlk",
    sort_name_az: "İsim (A'dan Z'ye)",
    sort_name_za: "İsim (Z-A)",
    action_new_sprite: "Yeni Karakter",
    action_new_project: "Yeni Proje",
    modal_save_all_title: "Tüm Değişiklikleri Kaydet",
    modal_save_all_desc: "Kaydedilecek varlıkları seçin:",
    modal_save_selected: "Seçileni Kaydet",
    action_saved: "Kaydedildi",
    modal_create_sprite_title: "Yeni Sprite Oluştur",
    modal_create_project_title: "Yeni Proje Oluştur",
    modal_add_sheet_title: "Yeni Sayfa Ekle",
    modal_rename_sheet_title: "Sayfayı Yeniden Adlandır",
    modal_rename_sprite_title: "Sprite'ı yeniden adlandır",
    modal_delete_sprite_title: "Sprite'ı Sil",
    modal_delete_project_title: "Projeyi Sil",
    modal_delete_sheet_title: "Sayfayı Sil",
    placeholder_sprite_name: "İsim",
    placeholder_project_name: "İsim",
    placeholder_sheet_name: "İsim",
    placeholder_new_name: "Yeni Ad",
    action_create: "Yaratmak",
    action_add: "Eklemek",
    action_rename: "Yeniden isimlendirmek",
    action_duplicate: "Kopyalamak",
    action_delete: "Silmek",
    action_cancel: "İptal etmek",
    confirm_delete_sprite: "Bu karakteri silmek istediğinizden emin misiniz?",
    confirm_delete_project: "Bu projeyi silmek istediğinizden emin misiniz? Tüm spritelar kaldırılacak.",
    confirm_delete_sheet: "Bu sayfayı silmek istediğinizden emin misiniz?",
    err_select_sprite: "Lütfen önce bir sprite seçin.",
    err_select_project: "Lütfen önce bir proje seçin.",
    err_name_empty: "Ad boş olamaz.",
    err_sprite_exists: "Bu isimde bir sprite zaten mevcut.",
    err_project_exists: "Bu isimde bir proje zaten mevcut.",
    err_no_content: "Kaydedilecek içerik yok.",
    err_no_changes: "Kaydedilecek değişiklik yok.",
    err_delete_last_sheet: "Son sayfa silinemiyor.",
    err_extract_frames: "Hiçbir kare çıkarılamadı.",
    err_indexeddb: "Yerel olarak kaydedilemedi. Tarayıcınız IndexedDB'yi desteklemiyor olabilir.",
    msg_upload_success: "Yükleme Başarılı: {0}",
    msg_upload_failed: "Yükleme Başarısız Oldu: {0}",
    msg_save_success: "Başarılı kaydet.",
    msg_saving: "Kaydediliyor...",
    msg_multi_save_result: "{0} varlık kaydedildi. {1} başarısızlık.",
    menu_title: "Menü",
    menu_save: "Kaydetmek",
    menu_save_all: "Tümünü Kaydet",
    menu_support: "Destek Ekibiyle İletişime Geçin",
    label_local_storage: "Yerel Depolama",
    label_sign_in: "Oturum aç",
    modal_export_title: "Sprite'ı Dışa Aktar",
    label_filename: "Dosya adı",
    label_format: "Biçim",
    action_export_confirm: "İhracat",
};

export default translations;
